module.exports = __webpack_public_path__ + "img/Puentes desactivado.d567b9f8.svg";